import { Reducer } from 'redux';
import baseReducer from '../../utilities/BaseReducer';
import UserModel from '../models/UserModel';
import UserActions from '../actions/userActions';
import IAction from '../../models/IAction';

  //TODO: IMPELEMENT 
  export interface IUserState {
    userList: UserModel[];
    userAdminList: UserModel[];
    createdUser: UserModel;
    deleteFinished: string;
    updatedUser: string;
    currentUser: UserModel;
    exportUserList: any;
    importUserList: any;
  }
  
  const initialState = {
    userList: [],
    userAdminList: [],
    createdUser: new UserModel({}),
    deleteFinished: '',
    updatedUser: '',
    currentUser: new UserModel({}),
    exportUserList: null,
    importUserList: null
  };
  
  export const userReducer: Reducer = baseReducer(initialState, {
    [UserActions.REQUEST_GET_USER_LIST_FINISHED]: (state: IUserState, action: IAction<UserModel[]>):IUserState => {
      return { 
        ...state,
        userList: action.payload!
      };
    },
    [UserActions.REQUEST_GET_USER_ADMIN_LIST_FINISHED]: (state: IUserState, action: IAction<UserModel[]>):IUserState => {
      return { 
        ...state,
        userAdminList: action.payload!
      };
    },
    [UserActions.REQUEST_POST_USER_FINISHED]: (state: IUserState, action: IAction<UserModel>):IUserState => {
      return { 
        ...state,
        createdUser: action.payload!
      };
    },
    [UserActions.REQUEST_GET_USER_FINISHED]: (state: IUserState, action: IAction<UserModel>):IUserState => {
      return { 
        ...state,
        currentUser: action.payload!
      };
    },
    [UserActions.REQUEST_DELETE_USER_FINISHED]: (state: IUserState, action: IAction<string>):IUserState => {
      return { 
        ...state,
        deleteFinished: action.payload!
      };
    },
    [UserActions.REQUEST_PUT_USER_FINISHED]: (state: IUserState, action: IAction<string>):IUserState => {
      return { 
        ...state,
        updatedUser: action.payload!
      };
    },
    [UserActions.REQUEST_EXPORT_USER_LIST_FINISHED]: (state: IUserState, action: IAction<any>):IUserState => {
      return { 
        ...state,
        exportUserList: action.payload!
      };
    },
    [UserActions.REQUEST_IMPORT_USER_LIST_FINISHED]: (state: IUserState, action: IAction<string>):IUserState => {
      return { 
        ...state,
        importUserList: action.payload!
      };
    },
  });